import React, { useEffect, useRef, useState } from 'react'

let autoComplete, map

const loadScript = (url, callback) => {
  let script = document.createElement('script') // create script tag
  script.type = 'text/javascript'

  // when script state is ready and loaded or complete we will call callback
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null
        callback()
      }
    }
  } else {
    script.onload = () => callback()
  }

  script.src = url // load by url
  document.getElementsByTagName('head')[0].appendChild(script) // append to head
}

function handleScriptLoad(updateQuery, autoCompleteRef, mapRef, props) {
  autoComplete = new window.google.maps.places.Autocomplete(
    autoCompleteRef.current,
    {
      types: ['establishment'],
      componentRestrictions: { country: 'br' },
      fields: ['ALL'],
    }
  )
  autoComplete.setFields(['address_components', 'formatted_address'])
  autoComplete.addListener('place_changed', () =>
    handlePlaceSelect(updateQuery)
  )

  initMap(mapRef.current, props.google_place_id)
}

async function handlePlaceSelect(updateQuery) {
  const addressObject = autoComplete.getPlace()
  updateQuery(addressObject)
}

function initMap(mapRef, placeId) {
  map = new google.maps.Map(mapRef, { zoom: 15 })
  const service = new google.maps.places.PlacesService(map)

  service.getDetails({ placeId }, (place) => {
    if (place.geometry.location) {
      createMarker(map, place)
      map.setCenter(place.geometry.location)
    }
  })
}

function createMarker(map, place) {
  return new google.maps.Marker({
    map,
    position: place.geometry.location,
  })
}

export default function PharmacyForm(props) {
  const [query, setQuery] = useState(props.name)
  const [place, setPlace] = useState()
  const [shouldForward, setShouldForward] = useState(!!props.forward)

  const [contactInfo, setContactInfo] = useState(props.contact_info)
  const [name, setName] = useState(props.name)
  const [address, setAddress] = useState(props.address)

  const autoCompleteRef = useRef(null)
  const mapRef = useRef(null)

  const updatePlace = (place) => {
    setPlace(place)
    setAddress(place.formatted_address)
    setName(place.name)

    if (place.geometry.location) {
      map.setCenter(place.geometry.location)
      createMarker(map, place)
    }
  }

  useEffect(() => {
    loadScript(
      `https://maps.googleapis.com/maps/api/js?key=AIzaSyDCmVmqBSCEt9JuMVd9oibE6WlUTId51Rg&libraries=places`,
      () => {
        handleScriptLoad(updatePlace, autoCompleteRef, mapRef, props)
      }
    )
  }, [''])

  return (
    <div className="pharmacy-form">
      <div className="Pharmacy-components info">
        <h3>💊 Envio Automático (opcional)</h3>
        <p className="muted">
          Envio automaticamente recebe notificações de receitas
          prescritas pela sua clínica através do Telegram.
        </p>

        <p className="muted">
          (Recipientes devem ser previamente cadastradas através do Bot do
          Telegram do FormulApp:{' '}
          <a href="https://t.me/formulapp_bot">https://t.me/formulapp_bot</a>.)
        </p>

        <input
          type="hidden"
          value={place?.place_id ?? props.google_place_id}
          name="pharmacy[google_place_id]"
        />

        <div className="pharmacy-box">
          <div className="pharmacy-fields">
            <div className="field forward">
              <input
                type="checkbox"
                checked={shouldForward}
                onChange={(e) => setShouldForward(e.target.checked)}
                name="pharmacy[forward]"
              />
              <label>Enviar Cópia</label>
            </div>

            <div className="field">
              <label className="field-phone">
                <i className="fab fa-whatsapp"></i>
                Telegram
              </label>

              <input
                type="tel"
                placeholder="Telegram para envio de receitas"
                name="pharmacy[contact_info]"
                onChange={(e) => setContactInfo(e.target.value)}
                value={contactInfo}
              />
            </div>

            <div className="field">
              <label>
                <i className="fal fa-hospitals"></i>
                Nome
              </label>
              <input
                onChange={(e) => setName(e.target.value)}
                value={name}
                name="pharmacy[name]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
